/*
 * @Author: 肖玲
 * @Date: 2023-02-28 15:59:45
 * @LastEditTime: 2023-02-28 16:27:51
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\channel-delivery-manage\index.js
 * 渠道发货管理
 */
import channelDeliveryAnalyRouter from "./modules/channelDeliveryAnalyRouter";
import industrialMaintenRouter from "./modules/industrialMaintenRouter";

const channelDeliveryManageRouter = [].concat(
  channelDeliveryAnalyRouter,
  industrialMaintenRouter,
)

export default channelDeliveryManageRouter